var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFencing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#6740E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.118 22.4838L11.0216 23.1166L8.74963 26.3613C8.60665 26.5653 8.325 26.615 8.12119 26.4721L7.9569 26.357C7.75286 26.2142 7.70312 25.9325 7.8461 25.7285L10.118 22.4838Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93625 21.4803C8.85879 20.1626 10.6775 19.842 11.9952 20.7645C13.3128 21.687 13.6336 23.5058 12.7109 24.8233",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3156 24.7525L12.4237 24.5985L12.7317 24.8138L12.6242 24.9679C12.2739 25.4692 11.7871 25.86 11.2211 26.0919C10.6744 26.3169 10.0751 26.3822 9.49265 26.2805C9.05389 26.2031 8.63684 26.0303 8.27205 25.7744L8.11821 25.6664L8.334 25.3579L8.48793 25.4665C8.80807 25.6904 9.17327 25.8421 9.558 25.9099C10.0701 25.9993 10.597 25.9415 11.0778 25.744C11.5772 25.5392 12.0069 25.1947 12.3157 24.7525L12.3156 24.7525Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9168 20.8768L11.8594 20.9587C11.7291 20.8673 11.6977 20.6876 11.7888 20.5575L11.7888 20.5575L22.0076 5.96325L22.0076 5.96318C22.0989 5.83307 22.2786 5.80123 22.4089 5.8926C22.5392 5.98395 22.5706 6.16364 22.4793 6.29384L11.9168 20.8768ZM11.9168 20.8768L11.8594 20.9587C11.9896 21.05 12.1693 21.0184 12.2606 20.8881L22.4793 6.29391L11.9168 20.8768Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4093 22.4837L21.5057 23.1165L23.7777 26.3612C23.9207 26.5652 24.2023 26.615 24.4062 26.472L24.5704 26.3569C24.7745 26.2141 24.8242 25.9325 24.6812 25.7285L22.4093 22.4837Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5911 21.4803C23.6686 20.1626 21.8498 19.842 20.5321 20.7645C19.2146 21.687 18.8938 23.5058 19.8165 24.8233",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2117 24.7525L20.1036 24.5984L19.7956 24.8138L19.9031 24.9679C20.2535 25.4692 20.7403 25.86 21.3063 26.0919C21.8529 26.3169 22.4523 26.3822 23.0347 26.2804C23.4735 26.2031 23.8905 26.0303 24.2553 25.7744L24.4091 25.6664L24.1933 25.3579L24.0394 25.4665C23.7193 25.6904 23.3541 25.8421 22.9693 25.9099C22.4573 25.9993 21.9303 25.9415 21.4496 25.744C20.9501 25.5391 20.5204 25.1947 20.2117 24.7525L20.2117 24.7525Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6106 20.8768L20.668 20.9586C20.7982 20.8673 20.8296 20.6876 20.7385 20.5575L20.7385 20.5575L10.5197 5.96323L10.5197 5.96316C10.4284 5.83306 10.2488 5.80121 10.1185 5.89259C9.98816 5.98394 9.95674 6.16363 10.048 6.29382L20.6106 20.8768ZM20.6106 20.8768L20.668 20.9586C20.5377 21.05 20.358 21.0184 20.2668 20.888L10.0481 6.29389L20.6106 20.8768Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFencing);
export default __webpack_public_path__ + "static/media/Fencing.afdc4dacc971c498f0f9e81dcba679b2.svg";
export { ForwardRef as ReactComponent };